import { CURATED_ACTIVE_MERCHANTS_VIEW } from './types';

export const triggerCuratedActiveMerchantsAreViewed = (merchants, suspendedMerchantName) => ({
  type: CURATED_ACTIVE_MERCHANTS_VIEW,
  merchants,
  suspendedMerchantName,
});
